// «Pianifica»: le attività accese, prima quelle che partono prima, con il loro innesco.
import { Link } from 'react-router-dom';
import { Icon } from '../../../components/Icon';
import type { Routine } from '../../../lib/api';
import { describeWhen, when } from '../../routines/when';
import { Widget } from '../Widget';

const ICON = {
  manual: 'play',
  input: 'keyboard',
  schedule: 'clock',
  condition: 'zap',
  hook: 'plug-zap',
} as const;

export function Schedule({ routines }: { routines: Routine[] | null }) {
  const on = (routines ?? [])
    .filter((r) => r.enabled)
    .sort((a, b) => (a.nextRun ?? '9').localeCompare(b.nextRun ?? '9'));
  return (
    <Widget
      title="Pianifica"
      icon="calendar-clock"
      count={routines ? on.length : undefined}
      detailsTo="/pianifica"
      detailsLabel="Pianifica"
      tint="sun"
    >
      {routines === null ? (
        <div className="t-caption faint">Leggo le attività…</div>
      ) : on.length === 0 ? (
        <div className="t-caption faint">Nessuna attività accesa.</div>
      ) : (
        <div style={{ display: 'grid', gap: 8 }}>
          {on.slice(0, 5).map((r) => (
            <Link key={r.id} to="/pianifica" className="agent-card dash-row">
              <span style={{ color: 'var(--dim)', display: 'inline-flex' }}>
                <Icon name={ICON[r.trigger]} size={16} />
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="t-strong trunc" style={{ display: 'block' }}>
                  {r.name}
                </span>
                <span className="t-caption dim trunc" style={{ display: 'block' }}>
                  {describeWhen(r.trigger, r.schedule, r.inputHint)}
                </span>
              </span>
              <span className="t-caption faint" style={{ whiteSpace: 'nowrap' }}>
                {r.nextRun ? when(r.nextRun) : r.lastRun ? `ultima ${when(r.lastRun.at)}` : ''}
              </span>
            </Link>
          ))}
        </div>
      )}
    </Widget>
  );
}
